<template>
  <div>
    <div :id="id" :style="{height: '280px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => '1'
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // goneType: []
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.$nextTick(() => {
          this.drawLine(newValue)
        })
      },
      immediate: true,
    },
  },
  methods: {
    drawLine (data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // // 获取哪一项不存在
      //  myChart.on("legendselectchanged", (paramas) => {
      //   if (!this.goneType.includes(paramas.name)) {
      //     this.goneType.push(paramas.name)
      //   } else {
      //     this.goneType = this.goneType.filter(item => item !== paramas.name )
      //   }
      // })
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderWidth:'1',
          borderColor:'gray',
          axisPointer: {
            type: 'shadow'
          },
          textStyle:{
            color:'black',
          },
          formatter:(params) => {
            let back = null
            switch (this.type) {
              case '1':
                back = '<span style="font-size: 14px;">' + params.name + params.percent + '%' +'</span>' + "<br/>" + "加油升数" + ':' + params.data.value + "升" + "<br/>" + "加油金额" + ':' + params.data.amount + "元" +  "<br/>" + "加油笔数" + ':' + params.data.oilCnt + "笔" 
                break
              case '2':
                back = '<span style="font-size: 14px;">' + params.name + params.percent + '%' +'</span>' + "<br/>" + "加油升数" + ':' + params.data.litre + "升" + "<br/>" + "加油金额" + ':' + params.data.value + "元" + "<br/>" + "加油笔数" + ':' + params.data.oilCnt + "笔" 
                break
              case '3':
                back = '<span style="font-size: 14px;">' + params.name + params.percent + '%' +'</span>' + "<br/>" + "加油升数" + ':' + params.data.litre + "升" + "<br/>" + "加油金额" + ':' + params.data.amount + "元" + "<br/>" + "加油笔数" + ':' + params.data.value + "笔" 
                break
            }
            return back
          },
        },
        legend: {
          orient: 'horizontal',
          right: 11,
          bottom: -6,
          data: data.legendData,
          formatter: function( name ) {
              return '{a|' + name + '}';
          },
          textStyle: {
              rich:{
                  a: {
                    width: 139
                  }
              }
          }
        },
        color : [ '#3377FF', '#FFAC52', '#ADCD40', '#FF5D5D' ],
        series: [{
          type: 'pie',
          radius: ['55%', '66%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
          // [
          //   { value: 1048, name: '已核销券', oil: 100, mon: 109 },
          //   { value: 735, name: '待核销券', oil: 1, mon: 91 },
          //   { value: 580, name: '已过期券', oil: 120, mon: 19 },
          // ]
        }]
      }, true)
    }
  }
}
</script>
<style scoped lang="less">

</style>